<template>
  <div>
    <div>
      <br />
      <div class v-if="data.data && data.data.length > 0">
        <a href data-toggle="modal" @click="download()">
          <button class="btn btn-outline-brand m-btn m-btn--outline">
            <i class="fas fa-download"></i> Baixar
          </button>
        </a>
      </div>
      <div class="page-amounts">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li class="page-item" :class="{ selected: amount === 3 }">
              <a @click="amount = 3" class="page-link paginate">3</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 10 }">
              <a @click="amount = 10" class="page-link paginate">10</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 50 }">
              <a @click="amount = 50" class="page-link paginate">50</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 100 }">
              <a @click="amount = 100" class="page-link paginate">100</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 150 }">
              <a @click="amount = 150" class="page-link paginate">150</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="paginator-info-top m-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
    </div>
    <div class="table-responsive">
      <div class="container-table">
        <table class="table table-striped- table-bordered table-hover table-checkable">
          <thead>
            <tr>
              <td
                nowrap
                class="text-center align-middle pointer"
                width="60"
                :class="{ 'table-sorted': sortType === 'id' }"
                @click="sortCall('id')"
              >
                ID Cliente
                <span
                  class="fas fa-caret-down sorted"
                  v-if="sortType === 'id' && !sortReverse"
                ></span>
                <span class="fas fa-caret-up sorted" v-if="sortType === 'id' && sortReverse"></span>
                <span class="fal fa-sort sort" v-if="sortType !== 'id'"></span>
              </td>
              <td nowrap class="text-center align-middle" width="300">Cliente</td>
              <td nowrap class="text-center align-middle" width="50">Valor</td>
              <td nowrap class="text-center align-middle" width="50">Status</td>
              <td nowrap class="text-center align-middle" width="50">Expiração</td>
              <td nowrap class="text-center align-middle" width="100">Produto</td>
              <td nowrap class="text-center align-middle" width="40">Motivo</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm m-input"
                  v-model="filters.id"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm m-input"
                  v-model="filters.name"
                />
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-for="(discount, id) in data.data" :key="id">
              <td class="text-center align-middle">{{ discount.id }}</td>
              <td class="text-left align-middle">{{ discount.customer.customerable.co_name }}</td>
              <td v-if="discount.is_percentage == 1" class="text-center align-middle">
                <money
                  v-bind="money"
                  class="form-control m-input"
                  v-model="discount.amount"
                ></money>
              </td>
              <td class="text-center align-middle" v-if="discount.is_percentage === 2">
                {{ discount.amount }}%
              </td>
              <td class="text-center align-middle">
                {{
                  discount.status === 2
                    ? 'Utilizado'
                    : discount.is_expired
                    ? 'Expirado'
                    : 'Pendente'
                }}
              </td>
              <td class="text-center align-middle">{{ discount.until_date | month }}</td>
              <td class="text-center align-middle">
                {{ discount.product ? discount.product.name : '-' }}
              </td>
              <td class="text-center align-middle">
                {{ discount.reason ? discount.reason.reason : '-' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div>
      <div class="paginator-info-bottom mt-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
      <div class="paginator-list">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li class="page-item" :class="{ disabled: data.current_page === 1 }">
              <a class="page-link paginate" @click="page = 1">
                <i class="fal fa-angle-double-left"></i>
              </a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === 1 }">
              <a class="page-link paginate" @click="page = data.current_page - 1">
                <i class="fal fa-angle-left"></i>
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
              v-if="data.current_page > 2"
            >
              <a class="page-link paginate" @click="page = data.current_page - 2">{{
                data.current_page - 2
              }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
              v-if="data.current_page > 1"
            >
              <a class="page-link paginate" @click="page = data.current_page - 1">{{
                data.current_page - 1
              }}</a>
            </li>
            <li class="page-item selected">
              <a class="page-link paginate">{{ data.current_page }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === data.last_page }"
              v-if="data.current_page < data.last_page"
            >
              <a class="page-link paginate" @click="page = data.current_page + 1">{{
                data.current_page + 1
              }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page + 1 === data.last_page }"
              v-if="data.current_page + 1 < data.last_page"
            >
              <a class="page-link paginate" @click="page = data.current_page + 2">{{
                data.current_page + 2
              }}</a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === data.last_page }">
              <a class="page-link paginate" @click="page = data.current_page + 1">
                <i class="fal fa-angle-right"></i>
              </a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === data.last_page }">
              <a class="page-link paginate" @click="page = data.last_page">
                <i class="fal fa-angle-double-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { Money } from 'v-money';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportDiscounts',
  props: ['start', 'finish'],
  components: { Money },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      currentCompanyDiscountName: '',
      data: {},
      sortType: localStorage.customerDiscountSortType
        ? localStorage.customerDiscountSortType
        : 'id',
      sortReverse: localStorage.customerDiscountSortReverse
        ? localStorage.customerDiscountSortReverse
        : false,
      amount: localStorage.customerDiscountDataAmount
        ? localStorage.customerDiscountDataAmount
        : 100,
      page: localStorage.customerDiscountDataPage ? localStorage.customerDiscountDataPage : 1,
      filters: {
        id: localStorage.customerDiscountFilterId ? localStorage.customerDiscountFilterId : '',
        name: localStorage.customerDiscountFilterName
          ? localStorage.customerDiscountFilterName
          : '',
        amount: localStorage.customerDiscountFilterAmount
          ? localStorage.customerDiscountFilterAmount
          : '',
        startDate: localStorage.startDate ? localStorage.startDate : '',
        finishDate: localStorage.finishDate ? localStorage.finishDate : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCreateDiscount() {
      return this.$store.state.showCreateDiscount;
    },
    showCompanyDiscount() {
      return this.$store.state.showCompanyDiscount;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/customer/discounts/downloadReport${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_desconto`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);
          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerDiscountFilterId', this.filters.id);
      localStorage.setItem('customerDiscountFilterName', this.filters.name);
      localStorage.setItem('customerDiscountFilterAmount', this.filters.amount);
      localStorage.setItem('customerDiscountDataAmount', this.amount);
      localStorage.setItem('customerDiscountDataPage', this.page);
      localStorage.setItem('customerDiscountSortType', this.sortType);
      localStorage.setItem('customerDiscountSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&value=${
        this.filters.value ? this.filters.value : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }&start=${this.start}&end=${this.finish}`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      this.getFilteredData();
    },
    getFilteredData() {
      const url = `${baseApiUrl}/v1/customer/discounts/all${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.clearAlert();
          this.$emit('updateLoading');
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
